<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <template v-if="checkParam()">
            <v-row align="center" justify="center" style="height:60px;">
              <v-col cols="6" class="pa-0" align="center">
                <v-row align="center" justify="start" class="ma-0 pa-0">
                  <v-col class="pa-0" align="center">
                    <v-btn depressed color="warning" @click="dayInit()" class="ma-1 span"><span class="caption">当日</span></v-btn>
                    <v-btn :outlined="view != 0" depressed color="primary" @click="view = 0" class="ma-1 span" ><span class="font-weight-bold">週</span></v-btn>
                    <v-btn :outlined="view != 1" depressed color="primary" @click="view = 1, onGotoToday()" class="ma-1 span"><span class="font-weight-bold">月</span></v-btn>
                    <v-btn :outlined="view != 2" depressed color="primary" @click="view = 2" class="ma-1 span"><span class="font-weight-bold">年</span></v-btn>
                  </v-col>
                  <v-col cols="2" class="pa-0" align="center">
                    <v-select
                      v-if="view != 0"
                      :items="$YEARS"
                      label="年度"
                      hideDetails
                      v-model.number="year"
                      :disabled="view == 0"
                      class="pr-1"
                      item-text="name"
                      item-value="value"
                    ></v-select>
                  </v-col>
                  <v-col class="py-0" align="center">
                    <v-select
                      hideDetails
                      :items='tempGroups'
                      label='教室'
                      v-model='group'
                      item-text="name"
                      item-value="key"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-row align="center" class="ma-0 pa-0">
                  <template v-if="view == 0">
                    <v-col cols="1" class="pa-0">
                      <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="offset -= 7">
                        <v-icon>mdi-arrow-left-drop-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="3" class="pa-0">
                      <v-text-field
                        label='期間'
                        class="mx-1"
                        :value="getToday()"
                        readonly
                        hideDetails
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="1" class="pa-0">
                      <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="offset = 0">
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="3" class="pa-0">
                      <v-text-field
                        class="ml-2"
                        :value="getTodayP7()"
                        readonly
                        hideDetails
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="1" class="pa-0">
                      <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="offset += 7">
                        <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </template>
                  <template v-if="view == 1">
                    <v-col cols="1" class="py-0">
                      <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="back">
                        <v-icon>mdi-arrow-left-drop-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="auto" class="pa-0">
                      <v-btn x-small icon v-for="i in 13" :key="i" class="ma-0" depressed color="transparent" style="height: 24px; width: 24px;" @click="gotoMonth(i)">
                        <v-avatar v-if="month != i" size="20" tile class="primary--text caption" style="border: 1px solid #1565C0;">{{ i }}</v-avatar>
                        <v-avatar v-else size="20" color="primary" tile class="white--text caption">{{ i }}</v-avatar>
                      </v-btn>
                    </v-col>
                    <v-col cols="1" class="py-0">
                      <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="forward">
                        <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </template>
                  <template v-if="view != 0 && checkRole()">
                    <v-row class="ma-0 pa-0 no-print" align="center" justify="end">
                      <v-col cols="auto" class="pa-0" align="center">
                        <v-btn v-if="view != 0" icon small depressed color="transparent" class="elevation-0 px-1" @click="onAdd()"><v-icon color="primary">mdi-square-edit-outline</v-icon></v-btn>
                      </v-col>
                      <v-col cols="auto" class="pa-0" align="center">
                        <v-btn v-if="view != 0" icon smayl depressed color="transparent" class="elevation-0 px-1" @click="onEdit()"><v-icon color="primary">mdi-book-open-outline</v-icon></v-btn>
                      </v-col>
                    </v-row>
                  </template>
                </v-row>
              </v-col>
            </v-row>
            <keep-alive>
              <app-schedule-weekly
                v-if="view == 0"
                :edit.sync="edit0"
                :add.sync="add0"
                :year="year"
                :month="month"
                :group="group"
                :events="events"
                :lines="lines"
                :tasks="tasks"
                :offset="offset"
                :param="param"
                :taskTemplates="filterTaskTemplates"
                :eventTemplates="filterEventTemplates"
                :type="type"
                @change="onChangeItem"
                @dismissed="onDismissed"
              >
              </app-schedule-weekly>
              <app-schedule-monthly
                ref="monthly"
                v-if="view == 1"
                :edit.sync="edit1"
                :year="year"
                :month="month"
                :group="group"
                :tempGroups="tempGroups"
                :add.sync="add1"
                :events="events"
                :lines="lines"
                :tasks="tasks"
                :taskTemplates="filterTaskTemplates"
                :eventTemplates="filterEventTemplates"
                :type="type"
                @change="onChangeItem"
                @dismissed="onDismissed"
              >
              </app-schedule-monthly>
              <app-schedule-yearly
                v-if="view == 2"
                :edit.sync="edit2"
                :year="year"
                :group="group"
                :tempGroups="tempGroups"
                :add.sync="add2"
                :events="events"
                :lines="lines"
                :eventTemplates="filterEventTemplates"
                :type="type"
                @change="onChangeItem"
                @dismissed="onDismissed">
              </app-schedule-yearly>
            </keep-alive>
          </template>
          <template v-else>
            <v-row :height="windowSize.y - 60 - 82 - 40" color="transparent">
              <app-schedule-weekly
                v-if="view == 0"
                :edit.sync="edit0"
                :add.sync="add0"
                :year="year"
                :month="month"
                :group="group"
                :events="events"
                :lines="lines"
                :tasks="tasks"
                :offset="offset"
                :param="param"
                :taskTemplates="filterTaskTemplates"
                :eventTemplates="filterEventTemplates"
                @dismissed="onDismissed"
              >
              </app-schedule-weekly>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Yearly from './Yearly.vue'
import Monthly from './Monthly.vue'
import Weekly from './Weekly.vue'
import EventDialog from '../../components/schedule/EventDialog.vue'
import TaskDialog from '../../components/schedule/TaskDialog.vue'
import EventEditDialog from '../../components/schedule/EventEditDialog.vue'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
Vue.component('app-schedule-yearly', Yearly)
Vue.component('app-schedule-monthly', Monthly)
Vue.component('app-schedule-weekly', Weekly)
Vue.component('app-event-dialog', EventDialog)
Vue.component('app-task-dialog', TaskDialog)
Vue.component('app-event-edit', EventEditDialog)
export default {
  props: [ 'param', 'type' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      holidays: 'holidays/holidays',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      scheduleTasks: 'scheduleTasks/events',
      templateTasks: 'templateTasks/templates',
      chatRefStatus: 'chatRefStatus/chatRef',
      windowSize: 'shared/windowSize'
    }),
    defaultHeight () {
      return 60
    },
    filterEventTemplates () {
      return JSON.parse(JSON.stringify(this.templateEvents)).sort(function (a, b) {
        var am = a.month < 4 ? a.month + 9 : a.month - 3
        var bm = b.month < 4 ? b.month + 9 : b.month - 3
        if (am < bm) return -1
        if (am > bm) return 1
        if (a.week < b.week) return -1
        if (a.week > b.week) return 1
        return 0
      })
    },
    filterTaskTemplates () {
      return JSON.parse(JSON.stringify(this.templateTasks)).sort(function (a, b) {
        if (a.month < b.month) return -1
        if (a.month > b.month) return 1
        if (a.week < b.week) return -1
        if (a.week > b.week) return 1
        return 0
      })
    }
  },
  data () {
    return {
      toggle_exclusive: 0,
      tempGroups: [],
      group: '*',
      year: null,
      month: null,
      search: null,
      view: 0,
      active: null,
      edit0: false,
      edit1: false,
      edit2: false,
      add0: false,
      add1: false,
      add2: false,
      events: [],
      lines: [],
      tasks: [],
      eventTemplates: [],
      offset: 0
    }
  },
  watch: {
    groups () {
      this.createGroups()
    },
    schools () {
      this.createGroups()
    },
    data () {
      this.createGroups()
    },
    edit1 () {
      if (this.view === 1) {
        this.onGotoToday()
      }
    },
    scheduleEvents () {
      this.createEvents()
    },
    scheduleTasks () {
      this.createTasks()
    },
    year () {
      this.createEvents()
      this.createTasks()
    },
    holidays () {
      this.createEvents()
    },
    templateEvents () {
      this.createEvents()
    },
    templateTasks () {
      this.createTasks()
    }
  },
  created () {
    moment.tz.setDefault('Asia/Tokyo')
    this.dayInit()
    this.createGroups()
    this.createEvents()
    this.createTasks()
  },
  methods: {
    dayInit () {
      this.year = this.getFY()
      this.offset = 0
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      this.month = parseInt(((moment().diff(moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day, 'd'), 'days')) / 28)) + 1
      if (this.view === 1) {
        this.onGotoToday()
      }
    },
    checkParam () {
      var value = false
      if (typeof this.param === 'undefined') {
        return true
      }
      if (this.param && this.param.type !== 'home') {
        value = true
      }
      if (!this.param) {
        value = true
      }
      return value
    },
    getToday () {
      moment.tz.setDefault('Asia/Tokyo')
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      return moment(now).add(this.offset, 'days').format('YYYY-MM-DD')
    },
    getTodayP7 () {
      moment.tz.setDefault('Asia/Tokyo')
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      return moment(now).add(this.offset + 7, 'days').format('YYYY-MM-DD')
    },
    checkRole () {
      return this.getPrivilegesLevel(this.data) <= 2
    },
    createGroups () {
      this.tempGroups = []
      if (!this.data) {
        return
      }
      if (this.getPrivilegesLevel(this.data) < 2) {
        this.tempGroups.push({ name: '全校', key: '*' })
      }

      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          if (typeof this.data.primaryGroup === 'undefined' || this.data.primaryGroup === null) {
            this.group = this.tempGroups[0].key
          } else {
            for (var x in this.tempGroups) {
              if (this.tempGroups[x].key === this.data.primaryGroup) {
                this.group = this.data.primaryGroup
                break
              }
            }
          }
        }
        index = this.chatRefStatus.findIndex(c => c.key === this.data.key)
        if (index !== -1) {
          keys = Object.keys(this.chatRefStatus[index].members)
          for (i in keys) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          keys = Object.keys(school.groups)
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
          if (this.tempGroups.length !== 0) {
            this.group = this.tempGroups[0].key
          }
          this.tempTaskGroups = JSON.parse(JSON.stringify(this.tempGroups))
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      }
    },
    createEvents () {
      this.events = [[], [], [], [], [], [], [], [], [], [], [], []]
      for (var i = 0; i < this.events.length; i++) {
        this.events[i] = [
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          []
        ]
      }
      this.lines = [[], [], [], [], [], [], [], [], [], [], [], []]
      for (i = 0; i < this.lines.length; i++) {
        this.lines[i] = [
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          []
        ]
      }
      const start = moment(this.year + '-04-01', 'YYYY-MM-DD')
      const end = moment((parseInt(this.year) + 1) + '-03-31', 'YYYY-MM-DD')
      const range = moment.range(start, end)
      for (i in this.holidays) {
        if (this.holidays[i].enable) {
          for (var x in this.holidays[i].events) {
            var date = moment(this.holidays[i].events[x].startDate, 'YYYY-MM-DD')
            if (range.contains(date)) {
              var mm = this.holidays[i].events[x].start.mm < 4 ? this.holidays[i].events[x].start.mm + 8 : this.holidays[i].events[x].start.mm - 4
              this.events[mm][this.holidays[i].events[x].start.dd - 1].push(this.holidays[i].events[x])
            }
          }
        }
      }
      for (i in this.scheduleEvents) {
        date = moment(this.scheduleEvents[i].startDate, 'YYYY/MM/DD')
        if (range.contains(date)) {
          mm = this.scheduleEvents[i].start.mm < 4 ? this.scheduleEvents[i].start.mm + 8 : this.scheduleEvents[i].start.mm - 4
          var event = JSON.parse(JSON.stringify(this.scheduleEvents[i]))
          var index = this.templateEvents.findIndex(template => template.key === event.template)
          if (index !== -1) {
            event['category'] = this.templateEvents[index].category
            event['title'] = this.templateEvents[index].title
            event['description'] = this.templateEvents[index].description
            event['period'] = this.templateEvents[index].period
            event['schools'] = this.templateEvents[index].schools
          } else {
            event['category'] = null
            event['title'] = null
            event['description'] = null
            event['period'] = 1
            event['groups'] = {}
            event['schools'] = {}
          }
          this.events[mm][this.scheduleEvents[i].start.dd - 1].push(event)
          if (event.duration > 1) {
            this.lines[mm][this.scheduleEvents[i].start.dd - 1].push(event)
            for (i = 1; i < event.duration; i++) {
              date = date.add(1, 'days')
              var m = date.month() < 3 ? date.month() + 9 : date.month() - 3
              var d = date.date()
              this.lines[m][d - 1].push(event)
            }
          }
        }
      }
    },
    createTasks () {
      this.tasks = [[], [], [], [], [], [], [], [], [], [], [], [], []]
      for (var i = 0; i < this.tasks.length; i++) {
        this.tasks[i] = [
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          [], [], [], [], [], [], [], [], [], [],
          []
        ]
      }
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var start = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day, 'd').format('YYYY-MM-DD')
      var end = moment(start).add((28 * 13) - 1, 'd').format('YYYY-MM-DD')
      const range = moment.range(start, end)
      for (i in this.scheduleTasks) {
        var date = moment(this.scheduleTasks[i].startDate)
        if (range.contains(date)) {
          var m = parseInt((moment(this.scheduleTasks[i].startDate, 'YYYY-MM-DD').diff(start, 'days') / 28))
          var d = parseInt((moment(this.scheduleTasks[i].startDate, 'YYYY-MM-DD').diff(start, 'days') % 28))
          var task = JSON.parse(JSON.stringify(this.scheduleTasks[i]))
          var index = this.templateTasks.findIndex(template => template.key === task.template)
          if (index !== -1) {
            task['category'] = this.templateTasks[index].category
            task['action'] = this.templateTasks[index].action
            task['title'] = this.templateTasks[index].title
            task['description'] = this.templateTasks[index].description
            task['schools'] = this.templateTasks[index].schools
          } else {
            task['category'] = null
            task['action'] = null
            task['title'] = null
            task['description'] = null
            task['groups'] = {}
            task['schools'] = {}
          }
          this.tasks[m][d].push(task)
        }
      }
    },
    gotoMonth (i) {
      this.month = i
      if (this.view === 1) {
        this.onGotoToday()
      }
    },
    back () {
      this.month -= 1
      if (this.month <= 0) {
        this.month = 13
      }
    },
    forward () {
      this.month += 1
      if (this.month > 13) {
        this.month = 1
      }
    },
    onGotoToday () {
      var vm = this
      this.$nextTick(() => {
        vm.$refs.monthly.onGotoToday()
      })
    },
    onChangeItem: function (value) {
      if (this.type && this.type === 'dialog') {
        this.$emit('change', { item: value.item })
      }
    },
    onAdd () {
      switch (this.view) {
        case 0:
          this.add0 = true
          break
        case 1:
          this.add1 = !this.add1
          break
        case 2:
          this.add2 = !this.add2
          break
        default:
          break
      }
    },
    onEdit () {
      switch (this.view) {
        case 0:
          this.edit0 = true
          break
        case 1:
          this.edit1 = !this.edit1
          break
        case 2:
          this.edit2 = !this.edit2
          break
        default:
          break
      }
    },
    onDismissed () {
      if (this.add2) {
        this.add2 = false
        return
      }
      if (this.add1) {
        this.add1 = false
        return
      }
      if (this.add0) {
        this.add0 = false
        return
      }
      if (this.edit2) {
        this.edit2 = false
        return
      }
      if (this.edit1) {
        this.edit1 = false
        return
      }
      if (this.edit0) {
        this.edit0 = false
      }
    }
  }
}
</script>

<style>
.v-btn.span {
  max-width: 14px !important;
  min-width: 14px !important;
  max-height: 32px !important;
}
@media screen {
  .v-sheet.T {
    text-align: center;
    border-top: 1px solid white !important;
  }

  .v-sheet.L-T {
    text-align: center;
    border-top: 1px solid white !important;
    border-left: 1px solid white !important;
  }

  .v-sheet.R-T {
    text-align: center;
    border-top: 1px solid white !important;
    border-right: 1px solid white !important;
  }

  .v-sheet.L-T-B {
    text-align: center;
    border-top: 1px solid white !important;
    border-left: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }

  .v-sheet.L-R-T {
    text-align: center;
    border-top: 1px solid white !important;
    border-left: 1px solid white !important;
    border-right: 1px solid white !important;
  }

  .v-sheet.L-R-T-B {
    text-align: center;
    border-top: 1px solid white !important;
    border-left: 1px solid white !important;
    border-right: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }
}

@media print {
  .v-sheet.T {
    text-align: center;
    border-top: 1px solid grey !important;
  }

  .v-sheet.L-T {
    text-align: center;
    border-top: 1px solid grey !important;
    border-left: 1px solid grey !important;
  }

  .v-sheet.R-T {
    text-align: center;
    border-top: 1px solid grey !important;
    border-right: 1px solid grey !important;
  }

  .v-sheet.L-T-B {
    text-align: center;
    border-top: 1px solid grey !important;
    border-left: 1px solid grey !important;
    border-bottom: 1px solid grey !important;
  }

  .v-sheet.L-R-T {
    text-align: center;
    border-top: 1px solid grey !important;
    border-left: 1px solid grey !important;
    border-right: 1px solid grey !important;
  }

  .v-sheet.L-R-T-B {
    text-align: center;
    border-top: 1px solid grey !important;
    border-left: 1px solid grey !important;
    border-right: 1px solid grey !important;
    border-bottom: 1px solid grey !important;
  }
}

@media screen {
  .scroll-y {
    overflow-y: auto !important;
  }
}

@media print {
  @page { margin: 0.1; }
  body {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  .print-btn {
    display: none;
  }
  .no-print {
    display: none;
  }
  .scroll-y {
    overflow-y: visible !important;
  }
}

</style>
